/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Sidebar_CategoriesInputs */

const en_directory_sidebar_categories = /** @type {(inputs: Directory_Sidebar_CategoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categories`)
};

const zh_directory_sidebar_categories = /** @type {(inputs: Directory_Sidebar_CategoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分类`)
};

/**
* | output |
* | --- |
* | "Categories" |
*
* @param {Directory_Sidebar_CategoriesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_sidebar_categories = /** @type {((inputs?: Directory_Sidebar_CategoriesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Sidebar_CategoriesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_sidebar_categories(inputs)
	return zh_directory_sidebar_categories(inputs)
});
export { directory_sidebar_categories as "directory.sidebar.categories" }